import React from 'react'

type Props = {
  createdAt?: string | null
  viewsCount?: number | null
  hasProof?: boolean | null
  className?: string
  compact?: boolean
  showViewsLabel?: boolean
  receiptStatus?: 'pending' | 'confirmed' | 'failed' | string | null
}

function cx(...parts: Array<string | false | null | undefined>) {
  return parts.filter(Boolean).join(' ')
}

export function formatRelativeTime(value?: string | null): string {
  if (!value) return 'Now'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return 'Now'
  const now = Date.now()
  const diffMs = Math.max(0, now - date.getTime())
  const hourMs = 60 * 60 * 1000
  const dayMs = 24 * hourMs
  if (diffMs < dayMs) {
    const h = Math.max(1, Math.floor(diffMs / hourMs))
    return `${h}h`
  }
  if (diffMs < 7 * dayMs) {
    const d = Math.max(1, Math.floor(diffMs / dayMs))
    if (d === 1) return 'Yesterday'
    return `${d}d`
  }
  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
}

export function formatViews(value?: number | null): string {
  const n = Math.max(0, Number(value || 0))
  if (n < 1000) return String(n)
  if (n < 1_000_000) return `${(n / 1000).toFixed(n >= 10_000 ? 0 : 1).replace(/\.0$/, '')}k`
  return `${(n / 1_000_000).toFixed(n >= 10_000_000 ? 0 : 1).replace(/\.0$/, '')}M`
}

export default function MicroMetaFooter({
  createdAt,
  viewsCount,
  className,
  compact = true,
  showViewsLabel = true,
}: Props) {
  const time = formatRelativeTime(createdAt)
  const views = formatViews(viewsCount)

  return (
    <div
      className={cx(
        'inline-flex items-center gap-1.5 text-white/70',
        compact ? 'text-[11px]' : 'text-xs',
        className,
      )}
      data-no-feed-tap="1"
    >
      <span>{time}</span>
      <span aria-hidden="true">{'\u2022'}</span>
      <span>{views}{showViewsLabel ? ' views' : ''}</span>
    </div>
  )
}
